module.exports = __webpack_public_path__ + "img/icon_googleplus_white.c7455d7.svg";